import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { ClientDtoKeysEnum } from '@zaoblako/shared/modules/client/enums/client-dto-keys.enum';
import { DtoMessageEnum } from '@zaoblako/shared/common/enums/dto.message.enum';
import { ClientCheckerKeysEnum } from '@zaoblako/shared/modules/client/enums/client-checker-keys.enum';
import { HelpdeskCheckerKeyEnum } from '@zaoblako/shared/modules/helpdesk/enum/helpdesk-checker-key.enum';
import type { ContragentFindInterface } from '@zaoblako/shared/modules/client/dtos/contragent/contragent-find.dto';
import type { HelpdeskTaskTypeFindInterface } from '@zaoblako/shared/modules/helpdesk/dto/task-type/helpdesk-task-type-find.dto';

import * as yup from 'yup';

/** Client create or update request body */
export interface ClientFormInterface {
  /** Client display name */
  name: string;
  /** Counterparties belonging to this client */
  contragents?: ContragentFindInterface[];
  /** Directions belonging to this client */
  helpdeskTaskTypes?: HelpdeskTaskTypeFindInterface[];
}

/** Client create or update request body - DTO schema */
export const ClientFormDto = SerdeDtoClass.create<ClientFormInterface>(ClientDtoKeysEnum.CLIENT_FORM_DTO, {
  name: {
    label: 'Название',
    serializer: yup
      .string()
      .min(1, DtoMessageEnum.EMPTY_STRING)
  },
  contragents: {
    label: 'Контрагенты',
    optional: true,
    checkers: [ClientCheckerKeysEnum.CONTRAGENT_ASSERT_EXISTS_BY_DTO],
    serializer: yup.array(yup.object({
      id: yup
        .number()
        .positive(DtoMessageEnum.NOT_POSITIVE)
        .integer(DtoMessageEnum.NOT_INTEGER),
    })) as yup.Schema<any>,
  },
  helpdeskTaskTypes: {
    label: 'Типы заявок HelpDesk',
    optional: true,
    checkers: [HelpdeskCheckerKeyEnum.HELPDESK_TASK_TYPE_ASSERT_EXISTS_BY_DTO],
    serializer: yup.array(yup.object({
      id: yup
        .number()
        .positive(DtoMessageEnum.NOT_POSITIVE)
        .integer(DtoMessageEnum.NOT_INTEGER),
    })) as yup.Schema<any>,
  },
});
